import { useCallback } from "react";

export function useHaptic() {
	const vibrate = useCallback((pattern: number | number[] = 15) => {
		if (typeof navigator !== "undefined" && "vibrate" in navigator) {
			navigator.vibrate(pattern);
		}
	}, []);

	const light = useCallback(() => vibrate(10), [vibrate]);
	const medium = useCallback(() => vibrate(20), [vibrate]);
	const heavy = useCallback(() => vibrate([30, 50, 30]), [vibrate]);
	const success = useCallback(() => vibrate([10, 30, 10]), [vibrate]);
	const error = useCallback(() => vibrate([50, 100, 50]), [vibrate]);

	const isSupported = typeof navigator !== "undefined" && "vibrate" in navigator;

	return { vibrate, light, medium, heavy, success, error, isSupported };
}
